module.exports = __webpack_public_path__ + "img/pasl.7356b0de.svg";